//import { UIPanel, UIButton, UIBreak, UIText, UIElement, UIDiv } from '@/components/assets/js/libs/ui.js';
import { UIPanel,UIText, UIRow, UIDiv, UIButton } from '@/components/assets/js/libs/ui.js';// eslint-disable-line no-unused-vars





function createButtonBlock(labelText) {
    const block = new UIDiv();

    block.dom.style.backgroundColor = 'rgba(10, 10, 10, 0.8)';
    block.dom.style.borderRadius = '10px';
    block.dom.style.padding = '10px';
    block.dom.style.margin = '0px 5px';
    block.dom.style.width = 'auto';
    block.dom.style.height = '50px';
    block.dom.style.display = 'flex';
    block.dom.style.flexDirection = 'row';
    block.dom.style.opacity = '0.3';

    block.dom.addEventListener('mouseenter', () => {
        block.dom.style.opacity = '1.0';
    });

    block.dom.addEventListener('mouseleave', () => {
        block.dom.style.opacity = '0.3';
    });
	const row = new UIRow();
	row.dom.style.margin = '5px 5px';
	row.dom.style.width = '74px';
	row.dom.style.display = 'flex';
	row.dom.style.justifyContent = 'center'; // 수평 가운데 정렬
	row.dom.style.alignItems = 'center';     // 수직 가운데 정렬
	
	const text = new UIText(labelText).setClass('Label');
	text.dom.style.textAlign = 'center';
	
	row.add(text);
	block.add(row);

    block.dom.addEventListener('click', () => {
		
			
		const filePath = 'example/Project/'+labelText+'/'+labelText;
		window.loadFBXFromPath(filePath+'.glb');
		window.loadPdfFile(filePath+'.pdf');


    });

    return block;
}


function loadProjectTextFile() {
    return fetch('example/Project/Project.txt')
        .then(response => {
            if (!response.ok) {
                throw new Error('파일을 불러올 수 없습니다.');
            }
            return response.text();
        })
        .then(text => {
            const lines = text.split('\n').map(line => line.trim()).filter(line => line.length > 0);
            return lines; // 줄 단위 배열
        })
        .catch(error => {
            console.error('Error:', error);
            return [];
        });
}


//function ViewportInfo( editor ) {
function Topbutton() {

	//const signals = editor.signals;
	//const strings = editor.strings;

	const container = new UIPanel();
	
    const wrapper = new UIDiv();
    wrapper.dom.style.display = 'flex';
    wrapper.dom.style.flexDirection = 'row'; // 가로 정렬
    wrapper.dom.style.margin = '70px 5px';   // 전체 wrapper의 마진
    wrapper.dom.style.justifyContent = 'flex-start'; // 좌측 정렬
    wrapper.dom.style.alignItems = 'center';





	loadProjectTextFile().then(lines => {
		console.log(lines); // ["첫번째 줄", "두번째 줄", ...]
		
		lines.forEach((line) => {
			const block = createButtonBlock(line);
			wrapper.add(block);
		});

		
        // 버튼들이 모두 추가된 후 첫 번째 버튼이 있을 때만 클릭
        if (wrapper.dom.children.length > 0) {
            const firstBlock = wrapper.dom.children[0]; // 첫 번째 자식 요소를 선택
            firstBlock.click(); // 첫 번째 버튼 클릭
        }
	
	});




	
    container.add(wrapper);



	/*
	const logoimg = document.createElement('img');
	logoimg.src = 'images/brand_white.png';
	logoimg.width = 200.0;
	const logo = new UIDiv();	
	logo.dom.appendChild(logoimg);	
	container.add(logo);
	*/

	container.setId( 'logo' );
	container.setPosition( 'absolute' );
	container.setLeft( '10px' );
	container.setTop( '00px' );

	container.setFontSize( '15px' );
	container.setColor( '#fff' );
	

	//const objectsText  = new UIText( '0' ).setTextAlign( 'right' ).setWidth( '60px' ).setMarginRight( '6px' );
	//const verticesText = new UIText( '0' ).setTextAlign( 'right' ).setWidth( '60px' ).setMarginRight( '6px' );
	//const trianglesText = new UIText( '0' ).setTextAlign( 'right' ).setWidth( '60px' ).setMarginRight( '6px' );
	//const frametimeText = new UIText( '0' ).setTextAlign( 'right' ).setWidth( '60px' ).setMarginRight( '6px' );

	//container.add( objectsText, new UIText( strings.getKey( 'viewport/info/objects' ) ), new UIBreak() );
	//container.add( verticesText, new UIText( strings.getKey( 'viewport/info/vertices' ) ), new UIBreak() );
	//container.add( trianglesText, new UIText( strings.getKey( 'viewport/info/triangles' ) ), new UIBreak() );
	//container.add( frametimeText, new UIText( strings.getKey( 'viewport/info/rendertime' ) ), new UIBreak() );
	/*
	signals.objectAdded.add( update );
	signals.objectRemoved.add( update );
	signals.geometryChanged.add( update );
	signals.sceneRendered.add( updateFrametime );
	*/
	//


	/*
	function update() {

		const scene = editor.scene;

		let objects = 0, vertices = 0, triangles = 0;

		for ( let i = 0, l = scene.children.length; i < l; i ++ ) {

			const object = scene.children[ i ];

			object.traverseVisible( function ( object ) {

				objects ++;

				if ( object.isMesh || object.isPoints ) {

					const geometry = object.geometry;

					vertices += geometry.attributes.position.count;

					if ( object.isMesh ) {

						if ( geometry.index !== null ) {

							triangles += geometry.index.count / 3;

						} else {

							triangles += geometry.attributes.position.count / 3;

						}

					}

				}

			} );

		}

		objectsText.setValue( objects.format() );
		verticesText.setValue( vertices.format() );
		trianglesText.setValue( triangles.format() );

	}

	function updateFrametime( frametime ) {

		frametimeText.setValue( Number( frametime ).toFixed( 2 ) );

	}
	*/
	return container;

}

export { Topbutton };
